package cc.easyandroid.easycompose.component.errorhandler

fun printError(exception: Exception) {
    exception.printStackTrace()
}
